import { FlaskConical, X } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';

export function DemoNotice() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <div className="flex items-start gap-3 rounded-2xl border border-warning/35 bg-warning/8 px-4 py-3 text-warning rise-in">
    <FlaskConical className="mt-0.5 size-5 shrink-0" />
    <div className="min-w-0 flex-1"><p className="text-sm font-semibold">Tryb demo · przykładowe dane</p><p className="mt-0.5 text-xs text-muted-foreground">Ceny w tej przestrzeni nie są rzeczywistymi, bieżącymi odczytami sklepów.</p></div>
    <Button aria-label="Ukryj informację o trybie demo" variant="ghost" size="icon" className="-m-2 shrink-0" onClick={() => setVisible(false)}><X /></Button>
  </div>;
}
